import type { Route } from '~/interfaces/routes.interfaces'

export const BASE_URL_QUICK_ACCESS = '/quick-access'

export const QUICK_ACCESS_ARTICLE_CFC: Route = {
  path: `${BASE_URL_QUICK_ACCESS}/article-cfc`
}

export const QUICK_ACCESS_ARTICLE_WITHOUT_CFC: Route = {
  path: `${BASE_URL_QUICK_ACCESS}/article-without-cfc`
}

export const QUICK_ACCESS_ARTICLE_ADAY: Route = {
  path: `${BASE_URL_QUICK_ACCESS}/article-aday`
}

export const QUICK_ACCESS_ARTICLE_AFP: Route = {
  path: `${BASE_URL_QUICK_ACCESS}/article-afp`
}

export const QUICK_ACCESS_ARTICLE_OPOINT: Route = {
  path: `${BASE_URL_QUICK_ACCESS}/article-opoint`
}
